export default __webpack_public_path__ + "b31858d.png";